module.exports = __webpack_public_path__ + "img/SL-M-180-240.c2c6f5f6.svg";